import { render, staticRenderFns } from "./ChartCard.vue?vue&type=template&id=4ff1c0bc&scoped=true&"
import script from "./ChartCard.vue?vue&type=script&lang=js&"
export * from "./ChartCard.vue?vue&type=script&lang=js&"
import style0 from "./ChartCard.vue?vue&type=style&index=0&id=4ff1c0bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff1c0bc",
  null
  
)

export default component.exports